/**
 * SOLID Review
 * S — Strong. One use case: stop watching the table's streams.
 * O — Strong. Nothing to decide.
 * L — Strong. Implements its use-case role exactly.
 * I — Strong. `execute`.
 * D — Strong. The watch port, injected.
 */
import type { IContextRequest } from '../ports/IContextRequest';
import type { ICommandNothing } from '../../domain/ports/schemas/TableMoves';
import type { TPortOutcome } from '../ports/PortResult';
import type { IUseCase } from '../uml-components/IUseCase';
import type { IConfigDepTable } from './IConfigDepTable';

/** Stop watching (FE1's unwatchTable). */
export class UnwatchTableUseCase implements IUseCase<ICommandNothing, TPortOutcome> {
  constructor(private readonly deps: IConfigDepTable) {}

  execute(ctx: IContextRequest, _command: ICommandNothing): Promise<TPortOutcome> {
    return this.deps.watch.unwatch(ctx);
  }
}
